import { Avatar, Box, Button, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import loadingGif from "../components/Loading/Animation_Process_Scripting.gif";
import { useProyecto } from "../data/ProyectoContext";
import { useAuthContext } from "../hooks/Auth";
import { useJobContext } from "../hooks/Jobs";

const LoadingPage = () => {
  const [loadingText, setLoadingText] = useState("Cargando...");
  const [isABP, setIsABP] = useState(false);
  const { proyecto } = useProyecto();
  const {
    isCompleted,
    isFailed,
    etapa,
    propuestaUsuario,
    handleStartJob,
    msgLoading,
    msgLoadingUnidad,
    userId,
  } = useJobContext();
  const { user } = useAuthContext();
  const navigate = useNavigate();

  const handleVerProyecto = () => {
    navigate(`/asistente/${isABP ? "abp" : "unidadtematica"}`);
  };

  const handleResendProyect = () => {
    handleStartJob(propuestaUsuario, etapa, "crear_proyecto");
  };

  useEffect(() => {
    if (isCompleted && !isFailed) {
      handleVerProyecto();
    }
  }, [isCompleted]);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingText((prevText) => {
        switch (prevText) {
          case "Cargando datos...":
            return "Procesando información...";
          case "Procesando información...":
            return "Generando ideas...";
          case "Generando ideas...":
            return "Estamos en ello, un momento...";
          case "Estamos en ello, un momento...":
            return "Estamos trabajando...";
          case "Estamos trabajando...":
            return "Cargando datos...";
          default:
            return "Cargando datos...";
        }
      });
    }, 3500); // Cambia el intervalo de tiempo según tus necesidades

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (proyecto) {
      if (proyecto.tipo_estructura === "Aprendizaje basado en proyectos") {
        setIsABP(true);
      } else if (proyecto.tipo_estructura === "Unidad Activa") {
        setIsABP(false);
      }
    }
  }, [proyecto]);

  const loadingMessage = isABP ? msgLoading : msgLoadingUnidad;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: "5%" }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          height="100vh"
        >
          {/* Si fue completado y no ha fallado */}
          {isCompleted && !isFailed && (
            <>
              <Typography variant="h6" align="center" mt={2}>
                Genial se proceso antes de lo esperado, puedes acceder
                directamente
              </Typography>
              <br />
              <Button variant="contained" onClick={handleVerProyecto}>
                Ver resultado
              </Button>
            </>
          )}
          {/* Si no esta completado y no ha fallado */}
          {!isCompleted && !isFailed && (
            <>
              <Typography variant="h3" align="center" mt={2}>
                ¡Genial, {user?.name}!
              </Typography>
              <Typography
                component="p"
                align="center"
                mt={2}
                dangerouslySetInnerHTML={{ __html: loadingMessage }}
              >
                {/* {msgLoading} */}
              </Typography>
              <br />
              <Avatar
                alt="Cargando..."
                src={loadingGif}
                sx={{ width: 200, height: 200 }}
              />
              <Typography variant="h6" align="center" mt={2}>
                {loadingText}
              </Typography>
            </>
          )}
          {/* Si definitivamente fallo */}
          {isFailed && (
            <Typography variant="h6" align="center" mt={2}>
              Lo siento, hubo un problema de comunicación con el servidor de
              UmmIA, por favor intentemoslo de nuevo.
              <br />
              <br />
              <Button
                variant="contained"
                onClick={handleResendProyect}
                data-amplify-analytics-on="click"
                data-amplify-analytics-name={`click-on-loading-failed-reenviar`}
                data-amplify-analytics-attrs={`onClick:handleResendProyect, userId:${userId}`}
              >
                Reenviar propuesta
              </Button>
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default LoadingPage;
